<ng-container *ngIf="filters || searchModel">
  <div class="pe-0 pe-sm-45 mb-4">
    <div class="d-flex event-hub-results__utilities flex-wrap flex-sm-nowrap mt-0">
      <div class="event-hub-results__utilities--search-input px-3 ps-sm-45 mb-25 mb-sm-0 flex-grow-1 search-min-width">
        <flo-search-input-next-gen [searchModel]="searchModel" (search)="handleSearch($event)" [stretchy]="true"></flo-search-input-next-gen>
      </div>
      <div class="event-hub-results__utilities--filters overflow-auto">
        <flo-filters
          [items]="dropdowns"
          (singleFilterClicked)="handleSingleFilterClicked($event)"
          (clearAllClicked)="handleClearAllClicked()"
          [clearAll]="clearAll"
        >
        </flo-filters>
      </div>
    </div>
    <div *ngIf="toggleFilter" data-test="results-toggle-filter" class="justify-content-end d-flex align-items-center mt-25 mb-4 pe-3 pe-sm-0">
      <flo-toggle
        [toggleFilter]="toggleFilter"
        (toggledTo)="handleSingleFilterClicked(toggleFilter.options[0])"
        toggleKey="0"
      >
      </flo-toggle>
    </div>
  </div>
</ng-container>
